import React from 'react';
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { patchCryptoLink } from 'redux/crypto-links/actions';
import { setLastPatchedId } from 'redux/common/actions';

import CommonInputField from 'components/elements/inputs/CommonInputField';

import validate from 'components/dashboard/crypto-links-content/validation/validate';

import './CryptoLinkAddress.css';

function CryptoLinkAddress(props) {
  const {
    patchCryptoLink,
    setLastPatchedId,
    linkItem,
    patchCryptoLinkError,
    lastPatchedId,
    cryptoServicesList,
    type,
    label,
  } = props;

  const validation = value => {
    if (type === 'address') {
      return validate(
        cryptoServicesList,
        linkItem.crypto_service.name,
        value,
      );
    }
    return null;
  };

  return (
    <div className="crypto-link-address__component">
      {label &&
        <div className="label">{label}</div>
      }
      <CommonInputField
        key={`crypto-link-address-input-key-${linkItem.id}`}
        editIcon
        initialValue={linkItem[type]}
        executedFunction={value => {
          const form = new FormData();
          form.append(type, value);
          patchCryptoLink(linkItem.id, form);
          setLastPatchedId(linkItem.id);
        }}
        serverErrors={
          lastPatchedId === linkItem.id &&
          patchCryptoLinkError &&
          (patchCryptoLinkError.address || patchCryptoLinkError.memo)
        }
        validationFunction={validation}
      />
    </div>
  );
}

CryptoLinkAddress.propTypes = {
  patchCryptoLink: PropTypes.func.isRequired,
  setLastPatchedId: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
  patchCryptoLinkError: PropTypes.object,
  lastPatchedId: PropTypes.number,
  cryptoServicesList: PropTypes.arrayOf(PropTypes.shape),
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
};

CryptoLinkAddress.defaultProps = {
  patchCryptoLinkError: null,
  lastPatchedId: null,
  cryptoServicesList: null,
  label: null,
};

const mapStateToProps = state => (
  {
    patchCryptoLinkError: state.cryptoLinksReducer.patchCryptoLinkError,
    lastPatchedId: state.commonReducer.lastPatchedId,
    cryptoServicesList: state.cryptoLinksReducer.cryptoServicesList,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCryptoLink,
    setLastPatchedId,
  },
)(CryptoLinkAddress);
